import React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import useAppVersion from './useAppVersion';

function AppUpdateSnackbar() {
  const { updateAvailable, refresh, dismiss } = useAppVersion();

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      message="A new version is available"
      action={
        <>
          <Button color="inherit" size="small" onClick={refresh}>
            Refresh
          </Button>
          <Button color="inherit" size="small" onClick={dismiss}>
            Dismiss
          </Button>
        </>
      }
    />
  );
}

export default AppUpdateSnackbar;
